import axios from '../../../axios';

export const getDynamicQueues=async (worker_name)=>{
    try{
        let  {data } = await axios.get(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/queue/?worker_name=${worker_name}`);
        return data;
    }catch(e){
        console.log('errror in get start/stop queue status')
    }
}